import isNil from 'lodash/isNil';

import { connect } from 'react-redux';

import TextSection from './text.jsx';
import { animationClassGenerator } from "zoomforth_page_version_viewer/utils.js";

import {
  getSectionSingletonContentItem,
  getSectionForContent
} from 'zoomforth_codesbane_viewer/reducers/index.js';

const mapStateToProps = (state, ownProps) => {
  const contentItem = getSectionSingletonContentItem(state, ownProps.section);
  let animationSettings;

  if (contentItem) {
    const sectionForContent = getSectionForContent(state, contentItem);
    animationSettings = sectionForContent.animationSettings;
  }

  let generatedAnimationClasses;
  let animationShouldNotRepeat;

  if(animationSettings){
    const {animationType, animationSpeed, animationRepeats} = animationSettings;
    if(!isNil(animationRepeats)){
      animationShouldNotRepeat = !animationRepeats;
    }
    generatedAnimationClasses = animationClassGenerator(animationType, animationSpeed);
  } 

  return {
    uuid: contentItem ? contentItem.uuid : null,
    fontSize: contentItem ? contentItem.font_size : null,
    htmlString: contentItem ? contentItem.renderedCaption : '',
    stylePresetClassName: contentItem ? contentItem.style_preset_classname : null,
    animationClasses: generatedAnimationClasses,
    animationRunsOnce: isNil(animationShouldNotRepeat) ? true : animationShouldNotRepeat

  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextSection);
